import apiClient from "./apiClient";
import { ensureRichTextHtml } from "../utils/riskReviewTemplate";

export const DEFAULT_RISK_REVIEW_TEMPLATE = {
  template_body:
    "<p>Risk Review on {{review_date}}.</p><p>As a result of this review, the risk has {{change_direction}}.</p><p>Current residual rating: {{residual_score}} ({{band_label}}).</p>",
  impact_section_default: "<p>Describe how this change impacts the business.</p>",
  mitigation_section_default: "<p>Describe remediation and mitigation actions.</p>",
};

let templateCache = null;
let templateInflight = null;

const cloneTemplate = (template) => ({
  template_body: ensureRichTextHtml(template?.template_body || DEFAULT_RISK_REVIEW_TEMPLATE.template_body),
  impact_section_default: ensureRichTextHtml(
    template?.impact_section_default || DEFAULT_RISK_REVIEW_TEMPLATE.impact_section_default
  ),
  mitigation_section_default: ensureRichTextHtml(
    template?.mitigation_section_default || DEFAULT_RISK_REVIEW_TEMPLATE.mitigation_section_default
  ),
});

export const clearRiskReviewTemplateCache = () => {
  templateCache = null;
  templateInflight = null;
};

export const getRiskReviewTemplate = async ({ force = false } = {}) => {
  if (templateCache && !force) {
    return { data: cloneTemplate(templateCache) };
  }
  if (templateInflight && !force) {
    return templateInflight;
  }

  templateInflight = apiClient
    .get("/risk-review-template")
    .then((response) => {
      templateCache = cloneTemplate(response?.data || {});
      return { ...response, data: cloneTemplate(templateCache) };
    })
    .finally(() => {
      templateInflight = null;
    });

  return templateInflight;
};

export const updateRiskReviewTemplate = async (payload) => {
  const response = await apiClient.put("/risk-review-template", payload);
  templateCache = cloneTemplate(response?.data || {});
  return { ...response, data: cloneTemplate(templateCache) };
};
